export const FIELD_NAMES = {
    LOOP_ACCESS_TOKEN: 'loopAccessToken'
};

export const MODE = {
    ACCOUNT: 'account',
    CAMPAIGN: 'campaign'
};

export const SETUP_KEYS = {
    ANALYTICS_SCRIPT: 'analytics-script',
    PURCHASE_EVENT: 'purchase-event'
};
